// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\(tabs)\\_layout.tsx"); } },
  "./(tabs)/account.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\(tabs)\\account.tsx"); } },
  "./(tabs)/admin.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\(tabs)\\admin.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\(tabs)\\index.tsx"); } },
  "./(tabs)/points.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\(tabs)\\points.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\_layout.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\login.tsx"); } },
  "./points/[id].tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\points\\[id].tsx"); } },
  "./points/[id]/edit.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\points\\[id]\\edit.tsx"); } },
  "./reset-password.tsx": { enumerable: true, get() { return require("C:\\Users\\ptorres\\Documents\\redeverde-expo\\app\\reset-password.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;